// EMAIL_PATTERN is a moderately permissive email validation regex
// Allows multiple consecutive separators (., _, -) in the local part,
// including trailing separators, and enforces structured domain rules
// ^                                      : Start of string
// ([a-zA-Z0-9]+                          : Local part starts with one or more alphanumeric characters
//   ([\._\-]+[a-zA-Z0-9]+)*              : Followed by zero or more groups of one or more separators (., _, -)
//                                          and alphanumeric characters
//   ([\._\-])*                           : Allows optional trailing separators at the end of the local part
// ){1,64}                                : Entire local part pattern must repeat 1 to 64 times
// @                                      : Literal "@" separating local and domain parts
// (                                      : Start of domain group
//   ([a-zA-Z0-9]                         : Each domain label starts with an alphanumeric character
//     ([a-zA-Z0-9\-]*[a-zA-Z0-9])?       : Optionally contains alphanumeric/hyphen characters, but must end with alphanumeric
//   \.)+                                 : Each label ends with a dot (.), and there must be at least one
//   [a-zA-Z]{2,}                         : Top-level domain must have at least two letters
// )                                      : End of domain group
// $                                      : End of string
const EMAIL_PATTERN = /^([a-zA-Z0-9]+([\._\-+]+[a-zA-Z0-9]+)*([\._\-])*){1,64}@(([a-zA-Z0-9]([a-zA-Z0-9\-]*[a-zA-Z0-9])?\.)+[a-zA-Z]{2,})$/;

export interface IToolboxValidateEmailResponse {
    valid: boolean;
    email?: string;
}

/**
 * Validate email address
 *
 * This function helps on validating if the given email is valid or not.
 * It is recommended to use the returned email response as this function will clean the email address from unexpected whitespaces and zero-width spaces
 *
 * @param email
 */
export function validateEmailWithoutTrim(email: string): IToolboxValidateEmailResponse {
    if (typeof email !== 'string') {
        return {
            valid: false,
            email,
        };
    }

    if (email.length > 254) {
        return {
            valid: false,
            email: email,
        };
    }

    const [prefix] = email.split('@');

    if (!prefix) {
        return {
            valid: false,
            email: email,
        };
    }

    if (prefix.length > 64) {
        return {
            valid: false,
            email: email,
        };
    }

    if (!EMAIL_PATTERN.test(email)) {
        return {
            valid: false,
            email: email,
        };
    }

    return {
        valid: true,
        email: email,
    };
}
